import rainbowStacksComponents from "components/components";

export function EnableUIButtons() {
    rainbowStacksComponents.rulesButton.setEnabled(true);
    rainbowStacksComponents.bonusBuyButton.setEnabled(true);
}

export function DisableUIButtons() {
    rainbowStacksComponents.rulesButton.setEnabled(false);
    rainbowStacksComponents.bonusBuyButton.setEnabled(false);
}

export function ShowUIButtons() {
    rainbowStacksComponents.rulesButton.show();
    rainbowStacksComponents.bonusBuyButton.show();
}

export function HideUIButtons() {
    rainbowStacksComponents.rulesButton.hide();
    rainbowStacksComponents.bonusBuyButton.hide();
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/ui-buttons.ts